<template>
  <el-card shadow="never">
    <template #header>
      <el-page-header @back="goBack">
        <template #content>
          <span class="text-large font-600 mr-3"> 成员列表 </span>
        </template>
        <template #extra>
          <div class="flex items-center">
            <el-button @click="add" type="primary">添加</el-button>
          </div>
        </template>
      </el-page-header>
    </template>
    <div>
      <el-form inline label-width="120px">
        <el-form-item label="所在班级">
          <el-select v-model="banwei" class="m-2" placeholder="请选择所在班级" size="large">
            <el-option
              label="全部"
              value="0"
            />
            <el-option
              v-for="item in bwlist"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="归属小组">
          <el-select v-model="juntuan" class="m-2" placeholder="请选择归属小组" size="large">
            <el-option
              label="全部"
              value="0"
            />
            <el-option
              v-for="item in jtlist"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="公司地址">
          <el-cascader v-model="areas" :options="cityData" @change="handleAreaChange" />
        </el-form-item>
        <el-form-item label="关键词">
          <el-input v-model="words" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sreach">搜索</el-button>
          <el-button type="primary" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
  <el-card shadow="never" style="margin-top:20px">
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="id" label="id" width="55" />
      <el-table-column prop="bwname" label="所在班级" width="90" />
      <el-table-column prop="jtname" label="归属小组" width="90" />
      <el-table-column prop="levelname" label="班级职位" width="90" />
      <el-table-column prop="realname" label="姓名" width="90" />
      <el-table-column prop="company" label="公司名"/>
      <el-table-column prop="mobile" label="联系电话" width="120" />
      <el-table-column prop="industryName" label="行业" width="110" />
      <el-table-column prop="content" label="主要产品" width="110" />
      <el-table-column label="区域" width="180">
        <template #default="scope">
          <p>{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="联系地址" />
      <!-- <el-table-column label="会员信息" width="300">
        <template #default="scope">
          <img :src="(scope.row.avatar ? scope.row.avatar : '../../assets/img/avatar.jpg')" style="width:40px;height:40px;display: inline-block;float: left;margin-right: 10px;"/>
          <span style="line-height:40px;display: inline-block;">{{scope.row.realname}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码" width="110" /> -->
      
      <!-- <el-table-column prop="levelname" label="职位" width="110" /> -->
      <!-- <el-table-column prop="bwname" label="班委" width="110" /> -->
      <!-- <el-table-column prop="addTime" label="添加时间" width="160"/>
      <el-table-column label="状态" width="60">
        <template #default="scope">
          <p v-if="scope.row.status==2">审核不通过</p>
          <p v-else-if="scope.row.status==1">正常</p>
          <p v-else>待审核</p>
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button v-if="scope.row.status==0" type="warning" size="small" @click="examine(scope.row.id)">审核</el-button>
          <el-button size="small" @click="edit(scope.row.id)">编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="del(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="float:right;margin:20px">
      <el-pagination
        v-model:page-size="pageSize"
        v-model:currentPage="current_page"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-card>
  <el-dialog v-model="examinebox" title="审核">
    <el-form :model="form" label-width="120px">
      <el-form-item label="审核状态">
        <el-radio-group v-model="examineData.status" class="ml-4">
          <el-radio label="1" size="large">通过</el-radio>
          <el-radio label="2" size="large">不通过</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="原因">
        <el-input v-model="examineData.reason" autocomplete="off" show-word-limit maxlength="50"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="setexamine">提交</el-button>
        <el-button @click="examinebox = false">取消</el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, ref } from 'vue'
import { ElMessage } from 'element-plus'
import api from '@/api/index.js'
import cityData from "@/utils/citydata.js"
export default defineComponent({
  setup() {
    let words = ref('')
    let examineData = ref({
      reason:'',
      id:'',
      status:"1",
    })
    let examinebox = ref(false)
    let page = ref(1)
    let pageSize = ref(10)
    let catebox = ref(false)
    let total = ref(0)
    let current_page = ref(1)
    let areas = ref([])
    const cityData = ref([])
    const handleSelectionChange = () => {
      console.log('go back')
    }
    const tableData = ref([])
    const jtlist = ref([])
    const bwlist = ref([])
    const juntuan = ref('0')
    const banwei = ref('0')

    return {
      examinebox,
      examineData,
      page,
      pageSize,
      current_page,
      tableData,
      catebox,
      total,
      words,
      jtlist,
      bwlist,
      juntuan,
      banwei,
      cityData,
      province:'',
      city:'',
      area:'',
      areas,
      handleSelectionChange
    };
  },
  methods: {
    goBack(){
      this.$router.go(-1)
    },
    handleAreaChange(e){
        let citylist = [],arealist = []
        for(var i in this.cityData){
          if(this.cityData[i].value==e[0]){
            this.province = this.cityData[i].value
            citylist = this.cityData[i].children
            for(var j in citylist){
              if(citylist[j].value==e[1]){
                this.city = citylist[j].value
                arealist = citylist[j].children
                for(var m in arealist){
                  if(arealist[m].value==e[2]){
                    this.area = arealist[m].value
                  }
                }
              }
            }
          }
        }
      },
    getJtList(){
        let that = this
        api.memberApi.getAllJt().then(res => {
            if (res.code === 0) {
              that.jtlist = res.data
            }else{
              ElMessage.error(res.message)
            }
        }).catch((res) => {
            ElMessage.error(res.message);
        })
      },
      getBwList(){
        let that = this
        api.memberApi.getAllBw().then(res => {
            if (res.code === 0) {
              that.bwlist = res.data
            }else{
              ElMessage.error(res.message)
            }
        }).catch((res) => {
            ElMessage.error(res.message);
        })
      },
    setexamine(){
      let that = this
      api.memberApi.setexamine(that.examineData).then(res => {
          if (res.code === 0) {
            ElMessage({
              message: res.message,
              type: 'success',
            })
            that.examinebox = false
            that.getList()
          }else{
            ElMessage.error(res.message)
          }
      }).catch((res) => {
          ElMessage.error(res.message);
      })
    },
    examine(id){
      this.examinebox = true
      this.examineData.id = id
      this.examineData.reason = ''
      this.examineData.status = "1"
    },
    add(){
      this.$router.push({path:'/member/add'})
    },
    edit(id){
      this.$router.push({path:'/member/detail',query:{id:id}})
    },
    handleCurrentChange(val){
      this.page = val
      this.getList()
    },
    del(id){
      let that = this
      api.memberApi.del({id:id}).then(res => {
          if (res.code === 0) {
            ElMessage({
              message: res.message,
              type: 'success',
            })
            that.getList()
          }else{
            ElMessage.error(res.message)
          }
      }).catch((res) => {
          ElMessage.error(res.message);
      })
    },
    sreach(){
      this.page = 1
      this.getList()
    },
    reset(){
      this.words = ''
      this.juntuan = '0'
      this.banwei = '0'
      this.province = ''
      this.city = ''
      this.area = ''
      this.areas = []
      this.getList()
    },
    getList(){
      let that = this
      api.memberApi.getList({words:that.words,page:that.page,juntuan:that.juntuan,banwei:that.banwei,province:that.province,city:that.city,area:that.area}).then(res => {
          if (res.code === 0) {
            that.pageSize = res.data.per_page
            that.tableData = res.data.data
            that.total = res.data.total
            that.current_page = res.data.current_page
          }else{
            ElMessage.error(res.message)
          }
      }).catch((res) => {
          ElMessage.error(res.message);
      })
    },
    EditLevel(info){
      this.title = '编辑职位'
      this.catebox = true
      this.formData.id = info.id
      this.formData.title = info.title
      this.formData.sort = info.sort
    },
    setLevel(){
      let that = this
      api.memberApi.setLevel(this.formData).then(res => {
          if (res.code === 0) {
              ElMessage({
                message: res.message,
                type: 'success',
              })
              that.catebox = false
              that.getList()
          }else{
            ElMessage.error(res.message)
          }
      }).catch((res) => {
          ElMessage.error(res.message);
      })
    }
  },
  mounted () {
    this.cityData = cityData
    this.getList()
    this.getBwList()
    this.getJtList()
  }
})
</script>
<style>

</style>